import type { AxiosRequestConfig } from "axios"
import { useMemo } from "react"

// this is the key for the cached pump statuses data
export function usePumpStatusesSWRKey(): AxiosRequestConfig | undefined {
  const swrKey = useMemo(
    () => {
      const url = "/api/v3/pump_status"

      return {
        url,
      }
    },
    [],
  )

  return swrKey
}
